const image_path = '/assets/img/';

export const initZoomModal = () => {
  const thumbnails = document.querySelectorAll('.zoom-icon');
  const header = document.querySelector('#header');
  
  // data-idが未設定の.zoom-iconに自動付与し、対応する.zoom要素も生成
  let autoIdCounter = 1;
  thumbnails.forEach((thumbnail) => {
    if (!thumbnail.getAttribute('data-id')) {
      const autoId = `auto-${autoIdCounter}`;
      thumbnail.setAttribute('data-id', autoId);
      
      // 対応する.zoom要素を生成
      const figureArea = thumbnail.closest('.figure-area, .figure-row');
      const img = thumbnail.parentElement.querySelector('img.image');
      if (figureArea && img) {
        const zoomElement = document.createElement('div');
        zoomElement.className = 'zoom-modal';
        zoomElement.setAttribute('data-id', autoId);
        
        // 元の画像のclassをチェック
        const imgClass = img.classList.contains('border-gray') ? ' class="border-gray"' : '';

        // close アイコンのパスは zoom-icon の実 src から導出（静的サイト/WPテーマ両対応）
        // 例: .../common/icon-zoom.svg → .../common/icon-close.png
        const closeSrc = thumbnail.src
          ? thumbnail.src.replace(/[^/]+$/, 'icon-close.png')
          : `${image_path}common/icon-close.png`;

        zoomElement.innerHTML = `
          <div class="content">
            <figure class="image">
              <img src="${img.currentSrc || img.src}"${imgClass}>
            </figure>
            <button class="close">
              <img src="${closeSrc}">
            </button>
          </div>
        `;
        figureArea.appendChild(zoomElement);
      }
      
      autoIdCounter++;
    }
  });

  // 自動生成後に全モーダルを取得（自動生成分も対象に含める）
  const zoomModals = document.querySelectorAll('.zoom-modal');

  // 画像クリックでモーダルを開く
  thumbnails.forEach((thumbnail) => {
    const id = thumbnail.getAttribute('data-id');

    thumbnail.addEventListener('click', () => {
      const correspondingZoom = document.querySelector(`.zoom-modal[data-id="${id}"]`);

      if (correspondingZoom) {
        correspondingZoom.classList.add('-active');
        document.body.style.overflow = 'hidden';
        if (header) header.classList.add('hidden');

      } else {
        console.error("No corresponding modal found for data-id:", id);
      }
    });
  });

  // モーダルを閉じる処理 (×ボタン)
  const closeButtons = document.querySelectorAll('.zoom-modal .close');
  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      const correspondingZoom = closeButton.closest('.zoom-modal');

      if (correspondingZoom) {
        correspondingZoom.classList.remove('-active');
        document.body.style.overflow = 'auto';
        if (header) header.classList.remove('hidden');
      }
    });
  });

  // モーダル外をクリックして閉じる処理
  zoomModals.forEach((zoom) => {
    zoom.addEventListener('click', (event) => {
      const zoomContent = zoom.querySelector('.content');
      if (zoomContent && !zoomContent.contains(event.target)) {
        zoom.classList.remove('-active');
        document.body.style.overflow = 'auto';
        if (header) header.classList.remove('hidden');
      }
    });
  });
};